import { render, staticRenderFns } from "./personalChat.vue?vue&type=template&id=568674fc&scoped=true"
import script from "./personalChat.vue?vue&type=script&lang=js"
export * from "./personalChat.vue?vue&type=script&lang=js"
import style0 from "./personalChat.vue?vue&type=style&index=0&id=568674fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568674fc",
  null
  
)

export default component.exports